import React, { createContext, useState, useContext, ReactNode } from "react";

interface DrawerState {
	trayVisible: boolean;
	isAnimating: boolean;
	showTray: () => void;
	hideTray: () => void;
}

// Create the context
const DrawerContext = createContext<DrawerState | undefined>(undefined);

// Props interface for the provider
interface DrawerStateProviderProps {
	children: ReactNode;
}

// Context provider component
export const DrawerStateProvider = ({ children }: DrawerStateProviderProps) => {
	const [trayVisible, setTrayVisible] = useState(false);
	const [isAnimating, setIsAnimating] = useState(false);

	//const toggleTray = () => setTrayVisible((prev) => !prev);
	const showTray = () => {
		console.log("showTray, startAnimation");
		setTrayVisible(true);
		setTimeout(() => {
			console.log("showTray, AnimationComplete");
			setIsAnimating(true);
		}, 300);
	};
	const hideTray = () => {
		console.log("hideTray, startAnimation");
		setIsAnimating(false);
		setTimeout(() => {
			console.log("hideTray, AnimationComplete");
			setTrayVisible(false);
		}, 300);
	};

	const value: DrawerState = {
		trayVisible,
		isAnimating,
		showTray,
		hideTray
	};

	return (
		<DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>
	);
};

// Custom hook to use the tray context
export const useDrawer = () => {
	const context = useContext(DrawerContext);
	if (!context) {
		throw new Error(
			"useDrawer must be used within a <DrawerStateProvider> component."
		);
	}
	return context;
};
